import {SearchCriteriaConfig} from "../../../../../page-components/common/search-criteria/type/search-criteria.type";
import {ILeavePeriod} from "../leave-request.types";
import React from "react";

export const LeaveTypeSearchCriteria = (
    leavePeriods: ILeavePeriod[]
): SearchCriteriaConfig[] => [
    {
        key: 'duration',
        label: 'Duration',
        inputType: 'date-range'
    },
    {
        key: 'session',
        label: 'Session',
        inputType: 'select',
        placeholder: "Select session",
        options: [
            {value: 'FULL_DAY', label: 'Full day'},
            {value: 'FIRST_HALF', label: 'First half'},
            {value: 'SECOND_HALF', label: 'Second half'},
        ]
    },
    // {
    //     key: 'state',
    //     label: 'Status',
    //     inputType: 'select',
    //     placeholder: "Select status",
    //     options: [
    //         {value: 'PENDING', label: 'Pending'},
    //         {value: 'APPROVED', label: 'Approved'},
    //         {value: 'REJECTED', label: 'Rejected'},
    //         {value: 'CANCELLED', label: 'Cancelled'},
    //     ]
    // },
    {
        key: 'leavePeriodId',
        label: "Select Leave Period",
        inputType: 'select',
        placeholder: "Select Leave Period",
        options: leavePeriods.map((leavePeriod) => ({
            value: leavePeriod.id,
            label: leavePeriod.displayName
        }))
    }
];